import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUrlEncodingCodec } from './../services/auth/encoder';
import { ExceptionCutOffTime } from '@models/exception-cut-off-time.model';
import { User } from '@models/user.model';
import { Fund } from '@models/fund.model';
import { map } from "rxjs/operators";
import { PossibleValuesRequest } from '@models/possible-values-request.model';
import { environment } from '@env/environment';
import { DatePipe } from '@angular/common';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';
const BASE_PATH = environment.basePathExternal
const BASE_PATHBFF = environment.basePath

/**
 * Service class to communicate with the REST services
 */
@Injectable({
  providedIn: 'root',
})
export class ExceptionCutOffTimeService {
  constructor(
    private profileManagerService: ProfileManagerService,
    public shared : SharedVariable,
    protected httpClient: HttpClient,
    protected encoder: HttpUrlEncodingCodec,
    private datePipe: DatePipe,
  ) { }


  isMasterBO() {
    return this.profileManagerService.isMasterBO();
  }
  /**
   * Validate the integrity of all fields of the given ExceptionCutOffTime
   * @param {ExceptionCutOffTime} body
   * @returns {  Observable<any>}
   */
  validate(body?: ExceptionCutOffTime): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/exceptionCutOffTimes/validate`,
      body,
      { headers: headers }
    )
  }
  /**
   * Export the selected elements with the givenFormat
   * @param {string} format
   * @param {string} keys
   * @param {string} criteria
   * @param {string} searchOrder
   * @param {ExceptionCutOffTime} body
   * @returns {  Observable<File>}
   */
   getClientsII(id): Observable<any> {
     let body= { id: id };
    return this.httpClient.post<any[]>(
      `${BASE_PATHBFF}/bff/master/get-view-profiles/users/list`,body
    );
  }

  export(
    format?: string,
    keys?: string,
    criteria?: string,
    searchOrder?: string,
    body?: ExceptionCutOffTime[]
  ): Observable<any> {
    let params = new HttpParams({ encoder: this.encoder })
    if (format !== undefined && format !== null) {
      params = params.append('format', format.toString())
    }
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    if (searchOrder !== undefined && searchOrder !== null) {
      params = params.append('searchOrder', searchOrder.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post(
      `${BASE_PATH}/exceptionCutOffTimes/export`,
      body,
      {
        params: params,
        headers: headers,
        observe: 'response',
        responseType: 'blob',
      }
    )
  }
  /**
   * Performs a search operation without pagination
   * @param {string} criteria
   * @param {string} order the order fields
   * @param {string} keys the chosen keys
   * @returns {  Observable<any[]>}
   */
  findAll(criteria?: string, order?: string, keys?: string): Observable<any[]> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    if (order !== undefined && order !== null) {
      params = params.append('order', order.toString())
    }
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/operation/getAllExceptionCutOffTime`,
      { params: params }
    )
  }
  /**
   * Find by the exceptionCutOffTime identifiers
   * @param {number} id
   * @param {string} keys the required keys
   * @returns {Observable<ExceptionCutOffTime>}
   */
  findByCode(id?: number, keys?: string): Observable<ExceptionCutOffTime> {
    let params = new HttpParams({ encoder: this.encoder })
    if (id !== undefined && id !== null) {
      params = params.append('id', id.toString())
    }
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    return this.httpClient.get<ExceptionCutOffTime>(
      `${BASE_PATH}/exceptionCutOffTimes`,
      { params: params }
    )
  }
  /**
   * Saves the exceptionCutOffTime
   * @param {ExceptionCutOffTime} body
   * @returns {Observable<ExceptionCutOffTime>}
   */
  insert(body?: ExceptionCutOffTime): Observable<ExceptionCutOffTime> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    if (body.fund) {
      body.fundCode = body.fund.fundCode
    }
    return this.httpClient.post<ExceptionCutOffTime>(
      `${BASE_PATH}/exceptionCutOffTimes`,
      body,
      { headers: headers }
    )
  }
  /**
   * Updates the exceptionCutOffTime
   * @param {ExceptionCutOffTime} body
   * @returns {Observable<ExceptionCutOffTime>}
   */
  update(body?: ExceptionCutOffTime): Observable<ExceptionCutOffTime> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    if (body.fund) {
      body.fundCode = body.fund.fundCode
    }
    if(!body.fromDate){
      body.fromDate =new Date(Date.UTC((new Date()).getFullYear(), (new Date()).getMonth(),(new Date()).getDate(),0, 0, 0));
    }
    if(body.fromDate){
      body.fromDate = this.getFormattedDate(body.fromDate)
    }
    if(body.toDate){
      body.toDate =  this.getFormattedDate(body.toDate)
    }
    
    
    if (body.cutOfTime.length!=8) {
      let d = this.datePipe.transform(body.cutOfTime , 'HH:mm:ss');
      body.cutOfTime = d.slice(0,-2)+"00"
    }
    //console.log( body.userName)
    if (body?.userName)
    {
      body.userEntity =body?.userName
    //   body.userEntity = {
    //     "login": body?.userName?.login
    //  }
    }else{
      body.userEntity = null
    //   body.userEntity = {
    //     "login": null
    //  }
    }
    
   delete body.userName;
    return this.httpClient.put<ExceptionCutOffTime>(
      `${BASE_PATH}/exceptioncutofftime/updateExceptionCutOffTime`,
      body,
      { headers: headers }
    )
  }
  /**
   * Delete the instances having a code from the given list
   * @param {string} codes
   * @returns {  Observable<number>}
   */
  delete(codes?: string): Observable<number> {
    let params = new HttpParams({ encoder: this.encoder })
    if (codes !== undefined && codes !== null) {
      params = params.append('codes', codes.toString())
    }

    return this.httpClient.delete<number>(`${BASE_PATH}/exceptionCutOffTimes`, {
      params: params,
    })
  }
  /**
   * Get the user
   * @param {string} code
   * @returns {Observable<User>}
   */
  getUser(code: string): Observable<User> {
    return this.httpClient.get<User>(
      `${BASE_PATH}/exceptionCutOffTimes/${code}/user`
    )
  }
  /**
   * Returns the possible values of the given field
   * @param {string} field
   * @param {string} criteria
   * @param {ExceptionCutOffTime} body
   * @returns {  Observable<any[]>}
   */
  getPossibleValues(
    field: string,
    criteria?: string,
    body?: ExceptionCutOffTime
  ): Observable<any[]> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any[]>(
      `${BASE_PATH}/exceptionCutOffTimes/${field}/possibleValues`,
      body,
      { params: params, headers: headers }
    )
  }
  /**
   * Returns the possible values of the given field translated using the current user profile
   * @param {string} field
   * @param {string} keys
   * @param {string} seperator
   * @param {string} criteria
   * @param {ExceptionCutOffTime} body
   * @returns {  Observable<any[]>}
   */
  getTranslatedPossibleValues(
    field: string,
    keys?: string,
    seperator?: string,
    criteria?: string,
    body?: ExceptionCutOffTime
  ): Observable<any[]> {
    let params = new HttpParams({ encoder: this.encoder })
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    if (seperator !== undefined && seperator !== null) {
      params = params.append('seperator', seperator.toString())
    }
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any[]>(
      `${BASE_PATH}/exceptionCutOffTimes/${field}/possibleValues/translated`,
      body,
      { params: params, headers: headers }
    )
  }
  /**
   * Evaluates the given formula against the given exceptionCutOffTime instance
   * @param {string} formula
   * @param {ExceptionCutOffTime} body
   * @returns {  Observable<any>}
   */
  evaluateFormula(
    formula?: string,
    body?: ExceptionCutOffTime
  ): Observable<any> {
    let params = new HttpParams({ encoder: this.encoder })
    if (formula !== undefined && formula !== null) {
      params = params.append('formula', formula.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/exceptionCutOffTimes/evaluate`,
      body,
      { params: params, headers: headers }
    )
  }
  /**
   * Validate the integrity of the fieldName in the given exceptionCutOffTime instance
   * @param {string} field
   * @param {ExceptionCutOffTime} body
   * @returns {  Observable<any>}
   */
  validateField(field: string, body?: ExceptionCutOffTime): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/exceptionCutOffTimes/${field}/validate`,
      body,
      { headers: headers }
    )
  }
  /**
   * Validate the integrity of all fields of the given ExceptionCutOffTime
   * @param {ExceptionCutOffTime} body
   * @returns {  Observable<any>}
   */
  validateAll(body?: ExceptionCutOffTime): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/exceptionCutOffTimes/validate/all`,
      body,
      { headers: headers }
    )
  }
  /**
   * Refresh entity keys
   * @param {string} keys the keys to refresh
   * @param {ExceptionCutOffTime} body
   * @returns {Observable<ExceptionCutOffTime>}
   */
  refreshKeys(
    keys?: string,
    body?: ExceptionCutOffTime
  ): Observable<ExceptionCutOffTime> {
    let params = new HttpParams({ encoder: this.encoder })
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<ExceptionCutOffTime>(
      `${BASE_PATH}/exceptionCutOffTimes/refresh`,
      body,
      { params: params, headers: headers }
    )
  }
  /**
   * Find the exceptionCutOffTime by code
   * @param {string} code
   * @param {string} keys the required keys
   * @returns {Observable<ExceptionCutOffTime>}
   */
  findByCodeAsString(
    code: string,
    keys?: string
  ): Observable<ExceptionCutOffTime> {
    let params = new HttpParams({ encoder: this.encoder })
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    return this.httpClient.get<ExceptionCutOffTime>(
      `${BASE_PATH}/exceptionCutOffTimes/${code}`,
      { params: params }
    )
  }
  /**
   * Deletes the exceptionCutOffTime instance with the given code
   * @param {string} code
   * @returns {  Observable<any>}
   */
  deleteOne(code: string): Observable<any> {
    return this.httpClient.delete<any>(
      `${BASE_PATH}/exceptioncutofftime/deleteExceptionCutOffTime/${code}`
    )
  }

  /**
   * Deletes all exceptionCutOffTimes with an optional criteria
   * @param {string} criteria
   * @returns {  Observable<number>}
   */
  deleteWithCriteria(criteria?: string): Observable<number> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }

    return this.httpClient.delete<number>(
      `${BASE_PATH}/exceptionCutOffTimes/delete`,
      { params: params }
    )
  }
  /**
   * The available formarts that can be used to export currencies
   * @returns {  Observable<any[]>}
   */
  getAvailableFormats(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/exceptionCutOffTimes/export/availableFormats`
    )
  }
  /**
   * Get the fund
   * @param {string} code
   * @returns {Observable<Fund>}
   */
  getFund(code: string): Observable<Fund> {
    return this.httpClient.get<Fund>(
      `${BASE_PATH}/exceptionCutOffTimes/${code}/fund`
    )
  }
  /**
   * Returns the possible funds
   * @param {PossibleValuesRequest} body
   * @returns {  Observable<any[]>}
   */
  getFundPossibleValues(body?: PossibleValuesRequest): Observable<any[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any[]>(
      `${BASE_PATH}/exceptionCutOffTimes/fund/possibleValues`,
      body,
      { headers: headers }
    )
  }
  /**
   * Returns the possible users
   * @param {PossibleValuesRequest} body
   * @returns {  Observable<any[]>}
   */
  getUserPossibleValues(body?: PossibleValuesRequest): Observable<any[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any[]>(
      `${BASE_PATH}/exceptionCutOffTimes/user/possibleValues`,
      body,
      { headers: headers }
    )
  }
  /**
   * Counts all the exceptionCutOffTimes with an optional criteria
   * @param {string} criteria
   * @returns {  Observable<number>}
   */
  count(criteria?: string): Observable<number> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null && criteria !== "") {
      if (this.isMasterBO()){
        params = params.append('criteria', criteria.toString() )
      }
      else{
        if(this.shared.checkValueOfInvestmentGroup.length > 0){
          params = params.append('criteria', criteria.toString() + "&(" + this.shared.listPTFBYUSERForFilter + ")")
        }
        else{
          params = params.append('criteria', criteria.toString() )

        }

       
      }
      
    }
    else{
      if (!this.isMasterBO()){
        if(this.shared.checkValueOfInvestmentGroup.length > 0){
          params = params.append('criteria',  this.shared.listPTFBYUSERForFilter )
        }
        
      }
      

    }
    return this.httpClient.get<number>(
      `${BASE_PATH}/exceptionCutOffTimes/count`,
      { params: params }
    )
  }
  /**
   * Return a new exceptioncutofftime instance initialized from the server
   * @returns {Observable<ExceptionCutOffTime>}
   */
  newInstance(): Observable<ExceptionCutOffTime> {
    return this.httpClient.get<ExceptionCutOffTime>(
      `${BASE_PATH}/exceptionCutOffTimes/new`
    )
  }
  /**
   * Performs a paginated search on exceptionCutOffTimes
   * @param {string} criteria
   * @param {string} order the order fields
   * @param {string} keys the chosen keys
   * @param {number} page the page number
   * @param {number} size the page size
   * @returns {  Observable<any[]>}
   */
  find(
    criteria?: string,
    order?: string,
    keys?: string,
    page?: number,
    size?: number
  ): Observable<any[]> {
    let params = new HttpParams({ encoder: this.encoder })
    let product = "";
    if(localStorage.getItem("s3brazilwebportalfe_locale_id") == "pt"){
      product = ", productTypePT+"
    }
    else{
      product = ", productTypeEN+"
    }
    if (criteria !== undefined && criteria !== null && criteria !== "") {
      if (this.isMasterBO()){
        params = params.append('criteria', criteria.toString() )
      }
      else{
        if(this.shared.checkValueOfInvestmentGroup.length > 0){
          params = params.append('criteria', criteria.toString() + "&(" + this.shared.listPTFBYUSERForFilter + ")")
        }
        else{
          params = params.append('criteria', criteria.toString() )
          
        }
       
      }
      
    }
    else{
      if (!this.isMasterBO()){
        if(this.shared.checkValueOfInvestmentGroup.length > 0){
          params = params.append('criteria',  this.shared.listPTFBYUSERForFilter )
        }
      
        
      }
      

    }
    if (order !== undefined && order !== null && order !=="") {
      if(order.includes('productType')){
        if(localStorage.getItem("s3brazilwebportalfe_locale_id") == "pt"){
          order = order.replace("productType","productTypePT")
        }
        else{
          order = order.replace("productType","productTypeEN")
        }

      }
      else{
        order=order+product
      }


      params = params.append('order', order.toString())
    }
    else{
      if(localStorage.getItem("s3brazilwebportalfe_locale_id") == "pt"){
        //order = order.replace("productType","productTypePT")
        params = params.append('order', "productTypePT+")
      }
      else{
        //order = order.replace("productType","productTypeEN")
        params = params.append('order', "productTypeEN+")
      }

    }
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    if (page !== undefined && page !== null) {
      params = params.append('page', page.toString())
    }
    if (size !== undefined && size !== null) {
      params = params.append('size', size.toString())
    }
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/exceptionCutOffTimes/search`,
      { params: params }
    )
  }

  getClientsByPTFCODE(id): Observable<any> {
    let params = new HttpParams({encoder: this.encoder})
    if (id){
      params = params.append('portfolioCode', id.toString())
    }
    
   return this.httpClient.get<any[]>(
     `${BASE_PATH}/userController/getUsersByPtf`,{ params: params }
   );
 }


  /**
   * Saves the exceptionCutOffTime
   * @param {ExceptionCutOffTime} body
   * @returns {Observable<ExceptionCutOffTime>}
   */
  save(body?: ExceptionCutOffTime): Observable<ExceptionCutOffTime> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    if (body.fund) {
      body.fundCode = body.fund.fundCode
    }
    if (body.cutOfTime.length!=8) {
      let d = this.datePipe.transform(body.cutOfTime , 'HH:mm:ss');
      body.cutOfTime = d.slice(0,-2)+"00"
    }
    /* if(!body.fromDate){
      body.fromDate =new Date(Date.UTC((new Date()).getFullYear(), (new Date()).getMonth(),(new Date()).getDate(),0, 0, 0));
    } */
    if(body.fromDate){
      body.fromDate = this.getFormattedDate(body.fromDate)
    }
    if(body.toDate){
      body.toDate =  this.getFormattedDate(body.toDate)
    }

    if(body?.userName){
      body.userEntity = {
        "login": body?.userName?.login
     }
    }
    else{
      body.userEntity = {
        "login": null
     }
    }
    



   if (body.userName != null){
    body.userName = body.userName.login
   }
    
    
    //console.log(body.userName)
    
   //delete body.userName ;

    return this.httpClient.post<ExceptionCutOffTime>(

      `${BASE_PATH}/exceptioncutofftime/saveExceptionCutOffTime`,
      body,
      { headers: headers }
    )
  }

  getFormattedDate(date){
    const currentDate = new Date(); // Date actuelle
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const seconds = currentDate.getSeconds();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
   const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
   return new Date(`${formattedDate} ${formattedTime}`);
    
  }
  

  findPTFByUSER(){
    let PTFBYUSERS = []
    let body ={}
    return this.httpClient.post<any>(
      `${BASE_PATH}/userController/getPtfsByCurrentUser`,body).pipe(map((result: any) => {
      if (result){
        PTFBYUSERS = result.map(portfolioCode => {
          
          const portfolio = this.shared.listAllPtfs.find(ptf => ptf.portfolioCode === portfolioCode);
          
          return {
            portfolioCode: portfolioCode,
            portfolioName: portfolio ?portfolioCode +" | " + portfolio.portfolioName : portfolioCode
          };
        });
      }
      return PTFBYUSERS;
    }));
  }

}
